import {
  createUserWithEmailAndPassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updatePassword
} from 'firebase/auth'
import { auth } from 'src/shims/firebase'
import { authWebLog } from 'src/utils/firebaseWebErrorReport'

export const signupManual = async (email: string, password: string) => {
  const emailDomain = email.includes('@') ? email.split('@')[1]?.toLowerCase() : 'invalid'
  authWebLog('signup_email_start', { emailDomain })
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password)
    authWebLog('signup_email_auth_ok', { uid: res.user.uid })
    try {
      await sendEmailVerification(res.user)
      authWebLog('signup_email_verification_sent', { uid: res.user.uid })
    } catch (verifyErr: unknown) {
      authWebLog('signup_email_verification_failed', {
        uid: res.user.uid,
        message: String((verifyErr as Error)?.message ?? verifyErr).slice(0, 240),
      })
      // Le compte existe déjà : ne pas faire échouer l’inscription (souvent réseau / anti-spam mobile).
    }
    return res
  } catch (err: unknown) {
    const e = err as { code?: string; message?: string }
    authWebLog('signup_email_error', {
      code: e?.code ?? 'unknown',
      message: (e?.message ?? String(err)).slice(0, 240),
    })
    throw err
  }
}

export const signinManual = async (email: string, password: string) => {
  authWebLog('signin_email_start', {
    emailDomain: email.includes('@') ? email.split('@')[1]?.toLowerCase() : 'invalid',
  })
  try {
    const cred = await signInWithEmailAndPassword(auth, email, password)
    authWebLog('signin_email_ok', { uid: cred.user.uid, emailVerified: cred.user.emailVerified })
    return cred
  } catch (err: unknown) {
    const e = err as { code?: string; message?: string }
    authWebLog('signin_email_error', {
      code: e?.code ?? 'unknown',
      message: (e?.message ?? String(err)).slice(0, 240),
    })
    throw err
  }
}

export const signUserOut = async () => signOut(auth)

export const resetPassword = async (email: string) => {
  await sendPasswordResetEmail(auth, email)
}

/** Changement de mot de passe (comptes email/mot de passe uniquement). */
export async function changePasswordWithCurrent(currentPassword: string, newPassword: string) {
  const u = auth.currentUser
  if (!u?.email) throw new Error('Aucun utilisateur connecté.')
  const cred = EmailAuthProvider.credential(u.email, currentPassword)
  await reauthenticateWithCredential(u, cred)
  await updatePassword(u, newPassword)
}
